import { rootDomainCookie, TRADEIN_ESTIMATE_COOKIE_NAME } from '@beef/shop-common';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';

import pushEvent, { SELECT_TRADE_IN_DEVICE_CAPACITY } from 'pushEvent/index';
import { selectTradeInBrandSelectedValue } from 'store/widgets/TradeInNewCalculator/brand/selectors';
import { selectDataForTradeInAnalytics } from 'store/widgets/TradeInNewCalculator/common/analytics-selectors';
import { selectTradeInTypeSelectedValue } from 'store/widgets/TradeInNewCalculator/deviceType/selectors';
import { fetchTradeInMaxPrice } from 'store/widgets/TradeInNewCalculator/maxPrice/actions';
import { selectTradeInModelSelectedValue } from 'store/widgets/TradeInNewCalculator/model/selectors';

import { api } from '../../../../api';

type FetchCapacityParams = {
  deviceType: string;
  brand: string;
  model: string;
};

export const setTradeInDeviceCapacity = createAction<string>('tradeId/setDeviceCapacity');
export const fetchTradeInDeviceCapacity = createAsyncThunk(
  'tradeId/fetchDeviceCapacity',
  async ({ deviceType, brand, model }: FetchCapacityParams): Promise<string[]> => {
    const result = await api.fetchCapacity(deviceType, brand, model);

    return result?.data?.capacity;
  },
);

export const setCapacityAndFetchMaxPrice = createAsyncThunk(
  'tradeId/setCapacityAndFetchMaxPrice',
  async (capacity: string, { getState, dispatch }): Promise<string> => {
    const deviceType = selectTradeInTypeSelectedValue(getState());
    const brand = selectTradeInBrandSelectedValue(getState());
    const model = selectTradeInModelSelectedValue(getState());

    dispatch(setTradeInDeviceCapacity(capacity));

    try {
      dispatch(fetchTradeInMaxPrice({ deviceType, brand, model, capacity }));
      rootDomainCookie.remove(TRADEIN_ESTIMATE_COOKIE_NAME);
      pushEvent(SELECT_TRADE_IN_DEVICE_CAPACITY, selectDataForTradeInAnalytics(getState()));

      return capacity;
    } catch (e) {
      captureException(e);
      throw new Error();
    }
  },
);
